module.exports = __webpack_public_path__ + "static/scale-model-of-fantasy-faire-in-garden-grove-california-0250617a1b2e97a0a4709311064f4886.png";